import React, { Component } from "react";
import { Redirect, Route, Switch, Link } from "react-router-dom";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import "react-big-calendar/lib/less/styles.less";
import "react-toggle-switch/dist/css/switch.min.css";
import "rc-drawer/assets/index.css";
import "styles/bootstrap.scss";
import "styles/app.scss";
import "styles/app-rtl.scss";
import AppLocale from "../lngProvider";

import MainApp from "app/index";
import ConnectionGate from "../components/ConnectionGate";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import Success from "../app/routes/extraPages/routes/success";
import Cancel from "../app/routes/extraPages/routes/cancel";
import Checkout from "../app/routes/extraPages/routes/checkout";

import { setInitUrl } from "../actions/Auth";
import asyncComponent from "util/asyncComponent";

/*const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      authUser ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/signin",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);*/

const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route {...rest} render={(props) => <Component {...props} />} />
);

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.toggle = this.toggle.bind(this);

    this.inicioRef = React.createRef();
    this.servicesRef = React.createRef();
    this.We = React.createRef();
    this.contact = React.createRef();
    this.scrollToMyRef = this.scrollToMyRef.bind(this);
  }

  componentWillMount() {
    //console.log = () => {};

    if (this.props.initURL === "") {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  scrollToMyRef(ref) {
    //console.log("scroll", ref);
    // run this method to execute scrolling.
    ref.current.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    const { match, location, locale, authUser, initURL, isDirectionRTL } =
      this.props;
    //console.log(this.props.history.location.pathname);

    if (location.pathname === "/") {
      if (initURL === "" || initURL === "/" || initURL === "/signin") {
        //return ( <Redirect to={'/app/dashboard/default'}/> );
        //console.log("ENTRA EN TO SIGNING 2");
        return <Redirect to={"/app/inicio"} />;
      } else {
        return <Redirect to={initURL} />;
      }

      /*if (authUser === null) {
        //console.log("ENTRA EN TO SIGNING", this.props);
        return <Redirect to={"/signin"} />;
      } else if (initURL === "" || initURL === "/" || initURL === "/signin") {
        //return ( <Redirect to={'/app/dashboard/default'}/> );
        //console.log("ENTRA EN TO SIGNING 2");
        return <Redirect to={"/app/inicio/menu"} />;
      } else {
        return <Redirect to={initURL} />;
      }*/
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ConnectionGate path={location.pathname}>
        <div style={{ width: "100%", overflow: "hidden" }} ref={this.inicioRef}>
          <div className="app-main">
            <Switch>
              <RestrictedRoute
                path={`${match.url}app`}
                authUser={authUser}
                component={MainApp}
              />
              <Route path="/signin" component={SignIn} />
              <Route path="/signup" component={SignUp} />
              <Route
                component={asyncComponent(() =>
                  import("app/routes/extraPages/routes/404")
                )}
              />
            </Switch>
          </div>

          <div
            ref={this.servicesRef}
            className="container-fluid bg-3 text-center"
            style={{
              display:
                this.props.history.location.pathname === "/signin"
                  ? "block"
                  : "none",
            }}
          />
        </div>
        </ConnectionGate>
      </IntlProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale, isDirectionRTL } = settings;
  const { authUser, initURL } = auth;
  return { locale, isDirectionRTL, authUser, initURL };
};

export default connect(mapStateToProps, { setInitUrl })(App);



// WEBPACK FOOTER //
// ./containers/App.js